import gsap from 'gsap'
import CustomEase from 'gsap/CustomEase'

const ease = CustomEase.create('custom1', 'M0,0 C0.496,0 0.098,1 1,1')

export const openAnimation = ({ menuOut, menuIn }) => {
  const tl = gsap.timeline()

  tl.fromTo(
    menuOut,
    {
      translateY: '100%',
    },
    {
      translateY: '0',
      duration: 1.1,
      ease,
    }
  )
  tl.fromTo(
    menuIn,
    {
      translateY: '-100%',
    },
    {
      translateY: '0',
      duration: 1.1,
      ease,
    },
    '<'
  )

  return tl
}

export const closeAnimation = ({ menuOut, menuIn }) => {
  const tl = gsap.timeline()

  tl.to(menuOut, {
    translateY: '-100%',
    duration: 1.1,
    ease,
  })
  tl.to(
    menuIn,
    {
      translateY: '100%',
      duration: 1.1,
      ease,
    },
    '<'
  )

  return tl
}
